import { Navigate, useLocation } from "react-router-dom";

export default function SectionRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/person/section to /people/:pgaId/membership/section
  const newPath = location.pathname.replace("/person/section", "/membership/section");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
